import { z } from 'zod';

/**
 * Supplier (source company) Master DTO.
 *
 * Backend endpoint: `/api/companies?role=source_supplier&party_type=supplier`.
 * Suppliers are the `source_company_id` referenced by inbound lots — operators
 * choose one from a dropdown rather than typing a UUID.
 *
 * The `companies` table is shared across all party types — this module
 * scopes itself to `source_supplier` rows.
 */

export const companyRoleValues = [
  'owner',
  'operator',
  'source_supplier',
  'destination',
  'buyer',
  'secondary_processor',
] as const;
export type CompanyRole = (typeof companyRoleValues)[number];

export const supplierSchema = z.object({
  company_id: z.string(),
  legal_name: z.string(),
  display_name: z.string(),
  company_role: z.enum(companyRoleValues),
  party_type: z.literal('supplier'),
  registration_info: z.string().nullable().optional(),
  active_flag: z.boolean(),
});

export type Supplier = z.infer<typeof supplierSchema>;

export const supplierCreateSchema = z.object({
  legal_name: z.string().min(1, '法人名（正式名称）を入力してください'),
  display_name: z.string().min(1, '表示名を入力してください'),
  registration_info: z.string().optional(),
});

export type SupplierCreateInput = z.infer<typeof supplierCreateSchema>;

export const supplierUpdateSchema = supplierCreateSchema.partial().extend({
  active_flag: z.boolean().optional(),
});
export type SupplierUpdateInput = z.infer<typeof supplierUpdateSchema>;
